import React from "react";
function AdminNavbar() {
  return (
    <>
      
    </>
  );
}

export default AdminNavbar;
